import React from 'react';
import { ApButtonMain } from '@alixpartners/ui-components';
import {
	Wrapper,
	ImageContainer,
	TextContainer,
	Title,
	Actions,
	ScrollContainer,
} from './NoData.styles';

export const NoDataFilters = ({ reset }) => {
	return (
		<ScrollContainer>
			<Wrapper>
				<ImageContainer hasFilters />
				<TextContainer>
					<Title>No data available for this combination of filters</Title>
					<Actions>
						<ApButtonMain iconName="baseline_undo" onClick={reset}>
							Reset filters
						</ApButtonMain>
					</Actions>
				</TextContainer>
			</Wrapper>
		</ScrollContainer>
	);
};
